import { loadAnalytics } from "analytics";
import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [consent, setConsent] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("analytics-consent");
    if (saved === "accepted") {
      setConsent(true);
      loadAnalytics();
    } else if (saved === "rejected") {
      setConsent(false);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("analytics-consent", "accepted");
    setConsent(true);
    loadAnalytics();
  };

  const reject = () => {
    localStorage.setItem("analytics-consent", "rejected");
    setConsent(false);
  };

  if (consent !== null) return null; // don’t show banner if already decided

  return (
    <div style={{
      position: "fixed",
      bottom: "10px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "#fff",
      padding: "15px 25px",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      display: "flex",
      gap: "10px",
      alignItems: "center",
      zIndex: 9999
    }}>
      <span>
        This website uses cookies for analytics. You can accept or reject tracking.
      </span>
      <button onClick={accept} style={{ padding: "8px 16px" }}>
        Accept
      </button>
      <button onClick={reject} style={{ padding: "8px 16px" }}>
        Reject
      </button>
    </div>
  );
}